import { Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, Button } from "@mui/material";
import styles from "./styles.module.css";

export default function ConfirmPopup(props) {
  const { data, handleClose, handleOkay, alertTitle, alertContent, successBtnName } = props;

  return (
    <Dialog
      open={!!data}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      BackdropProps={{ style: { zIndex: 1400 } }}
      PaperProps={{ style: { zIndex: 1401 } }}
    >
      <DialogTitle id="alert-dialog-title">{alertTitle}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{alertContent}</DialogContentText>
      </DialogContent>
      <DialogActions className={styles.btnSection}>
        <Button
          onClick={() => {
            handleClose("");
          }}
          className={styles.cancelButton}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            handleOkay(data);
            handleClose();
          }}
          className={styles.confirmButton}
          autoFocus
        >
          {successBtnName || "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
